import React, { useEffect, useMemo, useState } from 'react';
import BottomCompareItemSlider from './BottomCompareItemSlider';
import BottomCompareActions from './BottomCompareActions';
import ProductCompareRepository from "../../../repository/ProductCompareRepository";
import { useProductStore } from 'src/hooks/product';

const ProductCompareMiniSlider = (props) => {
    const [{ model_ProductCompare_data }, { }, { }] = useProductStore();
    const [firstServerCall, setFirstServerCall] = useState(true);

    useEffect(() => {
        async function fetchHere() {
            await new ProductCompareRepository().fetchAllData();
            setFirstServerCall(false)
        }

        if (firstServerCall) {
            fetchHere()
        }
    }, []);
    const channel = useMemo(() => new BroadcastChannel('product-compare-toggled'), []);
    channel.addEventListener('message', async () => {
        await new ProductCompareRepository().fetchAllData();
    });
    return (
        <>
            {model_ProductCompare_data && Object.keys(model_ProductCompare_data).length > 0 &&
                <div className="copmare-items-bottom-list position-fixed start-0">
                    <div className="container-fluid maxw100">
                        <div className="bs5 row">
                            {props.hideCompareSlider ? '' : <>
                                <BottomCompareItemSlider /> <BottomCompareActions /></>}
                        </div>
                    </div>
                </div>
            }
        </>
    );
}

export default ProductCompareMiniSlider;